// src/hooks/useUsers.ts
import { useEffect, useState } from "react";
import { api } from "../api/client";

export type UserRow = {
  id: string;
  name: string;
  email?: string;
  createdAt: number;
  status: string;
};

export function useUsers(statuses: string[]) {
  const [users, setUsers] = useState<UserRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const key = statuses.join(","); // строка-ключ для зависимостей

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const qs = new URLSearchParams();
        qs.set("statuses", key);
        const data = await api<{ ok: true; users: UserRow[] }>(
          `/admin/users?${qs.toString()}`,
          { method: "GET" }
        );
        setUsers(data.users);
      } catch (e: any) {
        setErr(e.message || String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, [key]);

  return { users, loading, err, setUsers };
}

